import React from 'react';
import './States.css';

export const LoadingState: React.FC<{ label?: string; fullscreen?: boolean }> = ({
  label = '불러오는 중...',
  fullscreen = false,
}) => (
  <div className={`ui-state ${fullscreen ? 'ui-state--fullscreen' : ''}`} role="status" aria-live="polite">
    <span className="ui-state__spinner" aria-hidden="true" />
    <p className="ui-state__desc">{label}</p>
  </div>
);

interface MessageStateProps {
  title: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

/** 빈 상태에는 메시지 + 다음 행동을 함께 둡니다. */
export const EmptyState: React.FC<MessageStateProps> = ({ title, description, icon, action }) => (
  <div className="ui-state">
    {icon && <div className="ui-state__icon" aria-hidden="true">{icon}</div>}
    <p className="ui-state__title">{title}</p>
    {description && <p className="ui-state__desc">{description}</p>}
    {action && <div className="ui-state__action">{action}</div>}
  </div>
);

/** 무엇이 실패했고 어떻게 복구하는지 알려줍니다. */
export const ErrorState: React.FC<MessageStateProps> = ({ title, description, action }) => (
  <div className="ui-state ui-state--error" role="alert">
    <p className="ui-state__title">{title}</p>
    {description && <p className="ui-state__desc">{description}</p>}
    {action && <div className="ui-state__action">{action}</div>}
  </div>
);

/** 좁은 화면에서 표가 페이지를 밀어내지 않도록 감쌉니다. */
export const TableScroll: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`ui-table-scroll ${className}`.trim()}>{children}</div>
);
